import PropTypes from 'prop-types';
import React from 'react';
import Spinner from './Spinner';
import { getComponentClasses } from '@99designs/utils/app';

export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    classes() {
        const variations = this.props.variations.slice();

        if (Boolean(this.props.icon) && !this.props.children) {
            variations.push('icon-no-label');
            variations.push('icon'); // NB: deprecated, kept for backwards compat
        }

        if (this.props.isSaving || this.props.iconAlignment === 'left') {
            variations.push('icon-left');
        }

        if (this.props.iconAlignment === 'right' && !this.props.isSaving) {
            variations.push('icon-right');
        }

        return getComponentClasses('button', variations);
    }

    attributes() {
        let attrs = {
            disabled: this.isDisabled(),
        };

        if (this.props.isActive) {
            attrs['data-button-selected'] = true;
        }

        const handledProps = [
            'onClick',
            'isDisabled',
            'isActive',
            'isSaving',
            'variations',
            'icon',
            'iconAlignment',
        ];

        // Allow for underlying button/anchor api
        Object.keys(this.props).forEach(key => {
            if (handledProps.indexOf(key) === -1) {
                attrs[key] = this.props[key];
            }
        });

        return attrs;
    }

    isDisabled() {
        return this.props.isDisabled || this.props.isSaving;
    }

    onClick(e) {
        if (!this.isDisabled()) {
            this.props.onClick(e);
        }
    }

    icon() {
        if (this.props.isSaving) {
            return (
                <span className="button__icon">
                    <Spinner />
                </span>
            );
        } else if (Boolean(this.props.icon)) {
            return <span className="button__icon">{this.props.icon}</span>;
        } else {
            return null;
        }
    }

    leftIcon() {
        const hasLeftIcon = this.props.icon && this.props.iconAlignment !== 'right';

        return this.props.isSaving || hasLeftIcon ? this.icon() : null;
    }

    rightIcon() {
        const hasRightIcon = this.props.icon && this.props.iconAlignment === 'right';

        return !this.props.isSaving && hasRightIcon ? this.icon() : null;
    }

    label() {
        return this.props.children ? (
            <span className="button__label">{this.props.children}</span>
        ) : null;
    }

    render() {
        const ButtonType = this.props.href ? 'a' : 'button';

        return (
            <ButtonType {...this.attributes()} onClick={this.onClick} className={this.classes()}>
                <span className="button__inner">
                    {this.leftIcon()}
                    {this.label()}
                    {this.rightIcon()}
                </span>
            </ButtonType>
        );
    }
}

Button.propTypes = {
    variations: PropTypes.array,
    href: PropTypes.string,
    iconAlignment: PropTypes.oneOf(['left', 'right']),
    isDisabled: PropTypes.bool,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    isSaving: PropTypes.bool,
    icon: PropTypes.element,
    type: PropTypes.oneOf(['submit', 'reset', 'button', 'menu']),
};

Button.defaultProps = {
    variations: ['primary'],
    isDisabled: false,
    isActive: false,
    isSaving: false,
    onClick() {},
    icon: null,
    href: null,
    iconAlignment: null,
    type: 'submit',
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Button.jsx